//@ts-check

import formatNumber from '@/core/filters/formatNumber';
import formatCurrency from '@/core/filters/formatCurrency';

const decimalFormat = ({ value }) => formatNumber(value ?? 0, {
  minimumFractionDigits: 2
});
const percentFormat = ({ value }) => formatNumber(value ?? 0, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}) + '%';
const numberFormat = ({ value }) => formatNumber(value ?? 0);
const currencyFormat = ({ value }) => formatCurrency(value ?? 0, 'en-US', 2);


/**
 * P
 */

/**
 * 
 * @type {Record<"pingData" | "errorData",
 * (Partial<Omit<import('@ag-grid-community/core').ColDef, 'valueFormatter'>>
 *  & ({
 *      headerName: keyof typeof import('./locales').default.en
 *      field: (data.structures.RttDashboardPingData | data.structures.RttDashboardErrorData)
 *      valueFormatter?: (({value: any}) => any) | undefined
 *      tooltipText?: keyof typeof import('./locales').default.en
 *     })
 * )[]>}
 */
export const columnSettings = {
  pingData: [
    {
      headerName: 'RTT_PINGS_RING_TREE_NAME',
      field: 'rttName'
    },
    {
      headerName: 'RTT_PINGS_RING_TREE_ID',
      field: 'rttId'
    },
    {
      headerName: 'RTT_PINGS_BIDS',
      field: 'acceptedPing',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'RTT_HIGHEST_BID',
      field: 'winsPing',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right',
      tooltipText: 'RTT_PINGS_HIGHEST_BID_TT'
    },
    {
      headerName: 'RTT_PINGS_REJECTED_BIDS',
      field: 'rejectedCount',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
  ],
  errorData: [
    {
      headerName: 'RTT_PINGS_RING_TREE_NAME',
      field: 'rttName',
      cellClass: 'no-click'
    },
    {
      headerName: 'RTT_PINGS_RING_TREE_ID',
      field: 'rttId'
    },
    {
      headerName: 'RTT_ERRORS_CALL_ACCEPTANCE_PARSING_REJECTION',
      field: 'rejectedCountBy:CallAcceptanceParsingRejection',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'RTT_ERRORS_MINIMUM_REVENUE',
      field: 'rejectedCountBy:MinimumRevenue',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'RTT_ERRORS_MISSING_BID_AMOUNT',
      field: 'rejectedCountBy:MissingBidAmount',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'RTT_ERRORS_MISSING_VALID_DYNAMIC_NUMBER',
      field: 'rejectedCountBy:MissingValidDynamicPhoneNumber',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'RTT_ERRORS_MAXIMUM_CALL_DURATION_EXCEEDED',
      field: 'rejectedCountBy:MaximumCallDurationExceeded',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'RTT_ERRORS_PING_TIMEOUT',
      field: 'rejectedCountBy:PingTimeout',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'RTT_ERRORS_API_REQUEST_FAILURE',
      field: 'rejectedCountBy:ApiRequestFailure',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'RTT_ERRORS_CONFIRMATION_API_FAILURE',
      field: 'rejectedCountBy:ConfirmationStepApiRequestFailure',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'RTT_ERRORS_CONFIRMATION_PING_TIMEOUT',
      field: 'rejectedCountBy:ConfirmationStepPingTimeout',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'RTT_ERRORS_CONFIRMATION_MISSING_VALID_DYNAMIC_NUMBER',
      field: 'rejectedCountBy:ConfirmationStepMissingValidDynamicPhoneNumber',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
  ]
};


export const rttPings = columnSettings.pingData;
export const rttErrors = columnSettings.errorData;
